import { motion } from "motion/react";
import { whyWorkWithUs } from "@/mocks/home";

const cardIcons = [
  "ri-team-line",
  "ri-lightbulb-flash-line",
  "ri-puzzle-line",
  "ri-shield-check-line",
];

export default function WhyWorkWithUsSection() {
  return (
    <section className="py-12 md:py-20 bg-primary">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10 md:mb-14"
        >
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-3">
            Why Work With Us
          </h2>
          <div className="w-16 h-1 bg-accent mx-auto rounded-full"></div>
          <p className="text-sm md:text-base text-white/80 mt-4 max-w-xl mx-auto">
            We combine deep industry expertise with a relentless focus on delivering measurable outcomes for our clients.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto">
          {whyWorkWithUs.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -6, scale: 1.02, transition: { duration: 0.25 } }}
              className="p-6 md:p-8 rounded-xl bg-primary-light/40 border border-white/10 hover:border-accent/40 transition-colors duration-300"
            >
              <motion.div
                whileHover={{ scale: 1.2, rotate: 8 }}
                transition={{ type: "spring", stiffness: 400 }}
                className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent/20 mb-4 flex-shrink-0"
              >
                <i className={`${cardIcons[index] || "ri-check-line"} text-accent text-lg`}></i>
              </motion.div>
              <h3 className="text-base md:text-lg font-bold text-white mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-white/70 leading-relaxed">
                {item.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}